module.exports = __webpack_public_path__ + "img/TTF.165ed3f5.png";